// extracted by css-extract-rspack-plugin
export default {"wrapper":"_5a4f3c00","image":"_353e3af4","isCover":"_7af32ae4","fixedHeight":"_a919297a"};